module.exports = __webpack_public_path__ + "static/img/zanwucai.284e2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zanwucai.png
// module id = mVOd
// module chunks = 1